import {
  REQUEST_STATION,
  RECEIVE_STATION,
  FAILED_STATION,
  BRUSH_DOMAIN_STATION,
  HOVER_STATION,
  HOVER_DATE_STATION,
  TOGGLE_PIN_STATION,
} from "./../actions/weatherStationActions";

export function weatherStation(
  state = {
    isFetching: false,
    loadError: false,
    station: null,
    fetchPeriod: false,
    showAllMeasurements: false,
    showFiveMinutesMeasurements: false,
    domain: false,
    lastDataPoint: false,
  },
  action
) {
  switch (action.type) {
    case REQUEST_STATION:
      return Object.assign({}, state, {
        loadError: false,
        isFetching: true,
      });
    case RECEIVE_STATION:
      return Object.assign({}, state, {
        isFetching: false,
        domain: false,
        station: action.station,
        fetchPeriod: action.fetchPeriod,
      });
    case FAILED_STATION:
      return Object.assign({}, state, {
        isFetching: false,
        loadError: true,
      });
    case BRUSH_DOMAIN_STATION:
      return Object.assign({}, state, {
        domain: action.domain,
      });
    default:
      return state;
  }
}

export function weatherStationAnalysis(
  state = {
    hoverDate: false,
    hovered: false,
    pinned: false,
    pinDate: false,
  },
  action
) {
  switch (action.type) {
    case HOVER_STATION:
      return Object.assign({}, state, {
        hovered: action.hovered,
      });
    case HOVER_DATE_STATION:
      return Object.assign({}, state, {
        hoverDate: action.hoverDate,
      });
    case TOGGLE_PIN_STATION:
      return Object.assign({}, state, {
        pinned: !state.pinned,
        pinDate: state.hoverDate,
      });
    default:
      return state;
  }
}
